import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { enableProdMode } from '@angular/core';
import { dsnSentry, environment, version } from './environments/environment';

if (environment.production) {
  enableProdMode();

  Sentry.setContext('app', {
    name: 'RS',
    version,
  });

  // я тут накакал, оно не должно ничего сломать, это сетает айпи адрес клиента в сентри, чтобы определить с какого города польователь (Никита)
  fetch(`https://checkip.amazonaws.com/`)
    .then((res) => {
      res
        .text()
        .then((txt) => Sentry.setTag('ip', txt))
        .catch(() => null);
    })
    .catch(() => null);

  Sentry.init({
    dsn: dsnSentry,
    integrations: [
      Sentry.browserTracingIntegration({}),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
